import React, { useState, useEffect, useRef } from 'react';
import { ref, onValue } from 'firebase/database';
import { useFirebase } from '../FirebaseContext';
import { useNavigate } from 'react-router-dom';
import { ChatCircleDots } from '@phosphor-icons/react';

const OpenChats = () => {
  const [chats, setChats] = useState([]);
  const navigate = useNavigate();
  const { currentFirebase } = useFirebase();
  const db = currentFirebase.database;

  useEffect(() => {
    const chatsRef = ref(db, 'chats');
    const unsubscribe = onValue(chatsRef, (snapshot) => {
      const openChats = [];
      snapshot.forEach((snap) => {
        const chat = { id: snap.key, ...snap.val() };
        if (chat.status === 'open') {
          // Count unread messages inline
          let unread = 0;
          if (chat.messages) {
            Object.values(chat.messages).forEach((msg) => {
              if (!msg.isRead && msg.senderRole === 'user') unread++;
            });
          }
          openChats.push({ ...chat, unread });
        }
      });
      setChats(openChats);
    });
    return () => unsubscribe();
  }, [db]);

  if (chats.length === 0) {
    return (
      <div className="dash-card">
        <div className="dash-card-header">
          <span className="dash-card-title">Otwarte zgłoszenia</span>
          <span className="dash-card-count">0</span>
        </div>
        <div style={{ textAlign: 'center', padding: 24, color: '#9ca3af', fontSize: 13 }}>
          Brak otwartych zgłoszeń
        </div>
      </div>
    );
  }

  return (
    <div className="dash-card">
      <div className="dash-card-header">
        <span className="dash-card-title">Otwarte zgłoszenia</span>
        <span className="dash-card-count">{chats.length}</span>
      </div>
      <div className="dash-chat-list">
        {chats.map((chat) => (
          <div
            key={chat.id}
            className="dash-chat-item"
            onClick={() => navigate('/chat', { state: { selectedChatId: chat.id } })}
          >
            <div className="dash-chat-icon">
              <ChatCircleDots size={18} weight="duotone" />
            </div>
            <div className="dash-chat-info">
              <span className="dash-chat-name">{chat.chatName || chat.creatorName || chat.id}</span>
              <span className="dash-chat-meta">{chat.creatorName || ''}</span>
            </div>
            {chat.unread > 0 && (
              <span className="dash-chat-badge">{chat.unread}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OpenChats;
